import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DxDataGridComponent } from "devextreme-angular";
import CustomStore from "devextreme/data/custom_store";
import notify from "devextreme/ui/notify";
import { forkJoin, lastValueFrom } from "rxjs";
import { LocalAgentsService, OcbLocalAgentCommand, OcbLocalAgentCommandStatus } from "../../core";
import { LocalAgentCommandComponent } from "../local-agent-command-popup/local-agent-command-popup.component";

const now = new Date();
const initialDates: [Date, Date] = [new Date(now), new Date(now)];

@Component({
    selector: 'app-file-transfer-ondemand-executions',
    templateUrl: './file-transfer-ondemand-executions.component.html'
})
export class FileTransferOnDemandExecutionsComponent implements AfterViewInit {
    @ViewChild('commandsGrid', { static: true }) dataGrid?: DxDataGridComponent;
    @ViewChild('commandDetailsPopup') commandDetailsPopup: LocalAgentCommandComponent;

    private commandsLabels: any;
    private commandsStatusLabels: any;
    private environmentId: string;
    private fileTransferId: string;
    
    protected dataSource: any;
    protected loadingMessage: string;
    protected maxDate: Date = now;
    protected selectedDates: [Date, Date] = initialDates;

    constructor(private agentsService: LocalAgentsService,
        private route: ActivatedRoute,
        private translateService: TranslateService) {
        this.displayCommand = this.displayCommand.bind(this);
        this.displayStatus = this.displayStatus.bind(this);
        this.displayName = this.displayName.bind(this);
    }

    ngAfterViewInit() {
        forkJoin({
            commandsLabels: this.translateService.get('localAgentsCommandsLabels'),
            commandsStatus: this.translateService.get('localAgentsCommandsStatus'),
            loadingMsg: this.translateService.get('_commons.loading')
        }).subscribe({
            next: (data) => {
                this.commandsLabels = data.commandsLabels;
                this.commandsStatusLabels = data.commandsStatus;
                this.loadingMessage = data.loadingMsg;
            },
            error: (err) => this.handleError(err)
        });

        this.route.params.subscribe(_ => {
            if (this.route.snapshot.params.ft === 'new') return;
            this.environmentId = this.route.snapshot.params.id;
            this.fileTransferId = this.route.snapshot.params.ft;

            this.dataSource = new CustomStore({
                key: 'id',
                load: async () => {
                    const query$ = this.agentsService.searchCommands(this.environmentId, null, this.fileTransferId, false, this.getSelectedStartDate(), this.getSelectedEndDate());
                    const response = await lastValueFrom(query$);
                    return {
                        data: response,
                        totalCount: response.length
                    };
                }
            });
        });
    }

    private handleError(error: any): void {
        let message: '';
        if (error instanceof HttpErrorResponse) {
            if (error.error.hasOwnProperty('message')) message = error.error.message;
            else if (error.error.hasOwnProperty('name')) message = error.error.name;
            else message = error.error;
        }
        else message = error;
        notify(message, 'error', 3000);
    }

    private getSelectedEndDate() { return this.selectedDates[1].toJSON().slice(0, 10); }

    private getSelectedStartDate() { return this.selectedDates[0].toJSON().slice(0, 10); }


    public displayCommand(rowData) { return this.commandsLabels[OcbLocalAgentCommand[rowData.command]]; }

    public displayName(rowData): string { return rowData.requestedByUser?.displayName ?? ''; }

    public displayStatus(rowData) { return this.commandsStatusLabels[OcbLocalAgentCommandStatus[rowData.status]]; }
    

    public onDatesChanged(): void {
        if (!this.dataGrid) return;
        this.dataGrid.instance.refresh();
    }

    public onRefreshButtonClick() {
        if (!this.dataGrid) return;
        this.dataGrid.instance.refresh();
    }

    public onRowDblClick(e) {
        if (!e?.data) return;
        this.commandDetailsPopup.agentCommand = e.data;
        this.commandDetailsPopup.visible = true;
    }
}